import React, { useState, useContext, useEffect } from 'react';
import ViewsContext from 'contexts/viewsContext';
import HourlySalesCumuChartGlance from './hourlySalesCumuChartGlance';
import HourlySalesCumuTableViewGlance from './hourlySalesCumuTableViewGlance';




export default function ToggleHourlySalesCumuGlance(props) {

    const { viewsState, setHourlySalesCumuToggleState } = useContext(ViewsContext);
    const [chartToggleClass, setChartToggleClass] = useState('');
    const [tableViewToggleClass, setTableViewToggleClass] = useState('');

    useEffect(() => {
        if (viewsState.chartsAndTableViewsConfigs.hourlySalesCumuToggleState === 'chart') {
            setTableViewToggleClass('togglable-hidden');
            setChartToggleClass('');
        }
        else if (viewsState.chartsAndTableViewsConfigs.hourlySalesCumuToggleState === 'tableView') {
            setChartToggleClass('togglable-hidden');
            setTableViewToggleClass('');
        }

    }, [viewsState]);

    const changeView = () => {
        if (viewsState.chartsAndTableViewsConfigs.hourlySalesCumuToggleState === 'chart') {
            setHourlySalesCumuToggleState('tableView');
        }
        else if (viewsState.chartsAndTableViewsConfigs.hourlySalesCumuToggleState === 'tableView') {
            setHourlySalesCumuToggleState('chart');
        }
    };

    if (viewsState.chartsAndTableViewsConfigs.hourlySalesCumuToggleState === 'chart') {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <HourlySalesCumuChartGlance data={props.data} viewState={chartToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }
    else {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <HourlySalesCumuTableViewGlance data={props.data} viewState={tableViewToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }

}

